import { useState, useRef, useEffect } from "react";
import { Snackbar, Alert } from "@mui/material";
import Moment from "moment";
import { useAuth } from "../components/AuthProvider.tsx";
import Comment from "../models/Comment.tsx"

interface Props {
  applicationId: number,
  businessId: number
}

const CommentComponent = ({ applicationId, businessId }: Props) => {
  const NewComment = () => {
    const comment: Comment = {
      CommentId: 0,
      ApplicationId: applicationId,
      DocumentId: null,
      Title: "",
      Filename: null,
      Note: "",
      IsVisible: false,
      CreatedOn: null
    }
    return comment;
  }

  const { authorization, SetAuthorization } = useAuth();
  const [comments, SetComments] = useState<Comment[]>([]);
  const [comment, SetComment] = useState<Comment>(NewComment);
  const isVisible = useRef(false);
  const [error, SetError] = useState(false);
  
  useEffect(() => {    
    LoadComments();
  }, []);

  const LoadComments = () => {
    fetch("/api/comments?token=" + authorization.Token + "&applicationId=" + applicationId)
      .then(response => response.json())
      .then(data => SetComments(data))
      .catch(error => console.log(error));
  }

  const Submit = (event: React.ChangeEvent<any>) => {
    event.preventDefault();

    var values = {
      Token: authorization.Token,
      ApplicationId: applicationId,
      DocumentId: comment.DocumentId,
      Title: comment.Title ? comment.Title : null,
      Note: comment.Note,
      IsVisible: isVisible.current.checked
    };

    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(values)
    };

    fetch("/api/comment", options)
      .then(response => response.json)
      .then(data => {
        LoadComments();
        SetComment(NewComment);
        isVisible.current.checked = false;
      })
      .catch(error => console.error(error));
  }

  const Upload = (event: React.ChangeEvent) => {
    const file = event.target.files[0];
    const filename = file.name;
  
    // Verify maximum file size
    if (file.size > 4000000) {
      SetError(true);
      return;
    }
  
    // Send document to server
    const data = new FormData();
    data.append("Token", authorization.Token);
    data.append("BusinessId", businessId.toString());    
    data.append("File", file);
    const options = {
      method: "POST",
      body: data
    };
  
    fetch("/api/document", options)
      .then(response => response.text())
      .then(data => SetComment((prevState) => ({ ...prevState, DocumentId: Number(data) })))      
      .catch(error => console.error(error));
  }

  const OnChange = (event: React.ChangeEvent<any>) => {
    const { name, value } = event.target;
    SetComment((prevState) => ({ ...prevState, [name]: value }));
  }

  return (
    <>
      <Snackbar open={error} onClose={() => SetError(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }} autoHideDuration={5000}>
        <Alert severity="error" variant="filled" sx={{ width: "100%", padding: 2 }}>
          Document exceeds the 4MB maximum file size.
        </Alert>
      </Snackbar>

      <h2>Application Notes</h2>
      {comments.length > 0 &&
        <div className="appNotes">
          {comments.map(comment => (
            <article key={comment.CommentId}>
              <div>{Moment(comment.CreatedOn).format("MMM DD, yyyy")}&nbsp;&nbsp;</div>
              <div>
                {comment.Note}
                {comment.DocumentId && <><br/><a href={'/api/document?token=' + authorization.Token + '&documentId=' + comment.DocumentId} download>{comment.Title}</a></>}
              </div>
            </article>
          ))}
        </div>
      }

      {authorization.IsAdministrator &&
        <form onSubmit={Submit}>
          <p>
            <label>Comment
              <input name="Note" type="text" value={comment.Note} onChange={OnChange} required />
            </label>
          </p>
          <p>
            <label className="biggerSpace">
              Document Title<br />
              <input name="Title" type="text" className="half" value={comment.Title} onChange={OnChange} />
              <label htmlFor="comment_document" className="custom-file-label">Upload</label>
              <input type="file" id="comment_document" className="custom-file-input" onChange={Upload} accept=".pdf, .doc, .docx" />
              <span className="file-name"></span>
            </label>
          </p>
          <p>
            <label className="form-control"> <input name="IsVisible" type="checkbox" ref={isVisible} /> Visible to Employer</label>
          </p>
          <p className="oddFormButton biggerSpace"><input type="submit" value="Add Note" /></p>
        </form>
      }
    </>
  )
};

export default CommentComponent;